import { useTranslation } from "react-i18next";
import { TeambookIcon } from "../../../default_images/TeambookIcon";
import { icons } from "../../../default_images/IconsList";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";

export const DeleteTaskWarning = ({ close, onYes = () => {}, onNo = () => {}, task }) => {
  const { t } = useTranslation();

  return (
    <TeambookDialog
      open
      title={t("dashboard.task_deletion")}
      onClose={close}
      withCloseButton
      content={
        <>
          <TeambookIcon
            style={{ width: 60, height: 60, margin: "20px auto" }}
            name={icons.WARNING_TRIANGLE}
            color="common"
          />

          <div className="delete-task-confirmation__text">
            <p style={{ margin: 0 }}>{t("dashboard.task_deletion_confirmation")}</p>

            <div className="flex">
              <p className="delete-task-confirmation__task-name">{task.name}</p>
              <p>?</p>
            </div>
          </div>
        </>
      }
      actionButtons={[
        { text: t("delete"), onClick: () => { onYes(task.value); close() } },
        { text: t("cancel"), onClick: () => { onNo(); close() } },
      ]}
    />
  );
};

DeleteTaskWarning.propTypes = {
  close: PropTypes.func.isRequired,
  onYes: PropTypes.func,
  onNo: PropTypes.func,
  task: PropTypes.object.isRequired,
}
